module.exports = __webpack_public_path__ + "img/bptc_map.a1f1918c.png";